import { render, staticRenderFns } from "./model-bzj-save.vue?vue&type=template&id=72893f0d&scoped=true"
import script from "./model-bzj-save.vue?vue&type=script&lang=js"
export * from "./model-bzj-save.vue?vue&type=script&lang=js"
import style0 from "./model-bzj-save.vue?vue&type=style&index=0&id=72893f0d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72893f0d",
  null
  
)

export default component.exports